<template>
  <!--  List of POGS-->
  <v-layout row v-if="listPOGs">
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ toolbarTitle }}
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn @click="$store.dispatch('map/getAllData')" flat>
            <v-icon>refresh</v-icon>&nbsp;
          </v-btn>
          <v-btn @click="editPOG({})" flat>
            <v-icon>add_location</v-icon>&nbsp; new
          </v-btn>
          <v-btn @click="close" flat> <v-icon>close</v-icon>&nbsp; exit </v-btn>
        </v-toolbar>

        <div class="pog-list">
          <list-pogs
            @edit-pog="editPOG"
            :map-data-loaded="mapDataLoaded"
            :pogs-changed="pogsChanged"
            :pogs="pogs"
          ></list-pogs>
        </div>
      </v-card>
    </v-flex>
  </v-layout>

  <!--  Create new POG-->
  <v-card v-else>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
        {{ activePOG.name || "Create New Project on the Ground" }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn @click="close" icon v-show="ableToClose">
        <v-icon>close</v-icon></v-btn
      >
    </v-toolbar>

    <new-pog
      :input-p-o-g="activePOG"
      :map-coordinates="mapCoordinates"
      @activate-map-click="$emit('activate-map-click')"
      @submit-pog="submitPOG"
      @delete-pog="deletePOG"
      @transfer-pog="transferPOG"
      @saving-needed="savingNeeded"
      @show-message="showMessage"
      @toggle-close="toggleClose"
    >
    </new-pog>
  </v-card>
</template>

<script>
import NewPOG from "@/components/pog/NewPOG";
import ListPOGs from "@/components/pog/ListPOGs";

export default {
  name: "ProjectsOnTheGo",

  components: {
    "new-pog": NewPOG,
    "list-pogs": ListPOGs,
  },

  props: {
    pogsChanged: Boolean,
    mapCoordinates: Object,
  },

  data() {
    return {
      ableToClose: true,
      listPOGs: true,
      activePOG: {},
      showAllPOGs: false,
      savingRequired: false,
    };
  },

  computed: {
    pogs() {
      return this.$store.state.map.pogs;
    },
    mapDataLoaded() {
      return this.$store.state.map.dataLoaded;
    },
    toolbarTitle() {
      return `${
        this.user
          ? this.user.username.endsWith("s")
            ? this.user.username + "'"
            : this.user.username + "'s"
          : ""
      } Projects on the Ground`;
    },

    user() {
      return this.$store.state.settings.user;
    },
  },

  watch: {
    mapCoordinates: {
      handler: function() {
        // Skip the list
        this.listPOGs = false;
      },
      deep: true,
    },
  },

  methods: {
    close() {
      if (this.listPOGs) this.$emit("close-pog");
      else if (this.savingRequired) {
        this.$swal
          .fire({
            title: "Confirm",
            text: "Exit without saving?",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonText: "Yes",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
          .then((response) => {
            if (response.value) {
              this.$emit("close-pog");
              if (!this.listPOGs) {
                let self = this;
                setTimeout(function() {
                  self.listPOGs = true;
                  self.$emit("close-pog");
                }, 100);
              }
            }
          });
      } else {
        this.listPOGs = true;
      }
    },

    toggleClose() {
      this.ableToClose = !this.ableToClose;
    },

    savingNeeded(value) {
      this.savingRequired = value;
    },

    editPOG(pog) {
      this.$emit("close-pog");
      this.listPOGs = false;
      this.activePOG = pog;
      let self = this;
      setTimeout(function() {
        self.$emit("close-pog");
      }, 100);
    },

    submitPOG(pog) {
      this.$store.dispatch("map/createPOG", pog);
      this.savingRequired = false;
    },

    deletePOG(pogID) {
      this.$emit("close-pog");
      this.listPOGs = true;
      this.$store.dispatch("map/deletePOG", pogID);
    },

    transferPOG(pogID, sourceUser, targetUser) {
      this.$emit("close-pog");
      this.listPOGs = true;
      this.$store.dispatch("map/transferPOG", { pogID, sourceUser, targetUser });
    },

    closePOG(id) {
      this.$emit("close-pog");
      this.listPOGs = true;
      this.$emit("remove-pog", id);
      this.activePOG = {};
    },

    showMessage(message, color) {
      this.$emit("show-message", message, color);
    },
  },
};
</script>

<style>
.pog-list {
  height: 600px;
  overflow-y: auto;
}
</style>
